import { Card, LearnMoreLink, Text } from '@ui/themed';
import type { PropsWithChildren, ReactNode } from 'react';
import type { CardBadge } from '../../../components/ui/card/types';

export function WidgetSection({
  title,
  subtitle,
  learnMoreUrl,
  badges,
  children,
}: PropsWithChildren<{
  title: string;
  subtitle?: ReactNode;
  learnMoreUrl?: string;
  badges?: CardBadge[];
}>) {
  return (
    <Card>
      <Card.Header headingLevel="h2" badges={badges}>
        {title}
      </Card.Header>
      {(subtitle || learnMoreUrl) && (
        <Text size="sm" variant="secondary">
          {subtitle}
          {learnMoreUrl && (
            <>
              {' '}
              <LearnMoreLink link={learnMoreUrl} />
            </>
          )}
        </Text>
      )}
      <Card.Body>
        <div className="flex flex-col gap-4">{children}</div>
      </Card.Body>
    </Card>
  );
}
